import React from "react";
import { RightArrowIcon } from "../../../assets/svg/RightArrowIcon";
import styled from "styled-components";

export const VerticalLineSection = () => {
  return (
    <VerticalSectionContainer>
      <VerticalLineIconSection>
        <VerticalLine />
        <RightArrowIcon />
        <VerticalLine />
      </VerticalLineIconSection>
      <VerticalLine />
    </VerticalSectionContainer>
  );
};

const VerticalSectionContainer = styled.div`
  display: grid;
  grid-template-rows: 4em auto;
  margin-left: -1000%;
`;

const VerticalLineIconSection = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  justify-content: center;
  justify-items: center;
  border-bottom: 1px solid #ebeeff;
`;

const VerticalLine = styled.div`
  border-right: 1px solid #ebeeff;
  height: 100%;
  width: 1px;
  align-self: center;
  justify-self: center;
`;
